import { StyleSheet } from 'react-native';

import { commonEmptyState, commonCard } from '../common';
import { container, spacing } from '../theme';

import { buttonStyles } from './buttons';

// Styles for list screens
export const listStyles = StyleSheet.create({
	container: {
		...container.screen,
	},
	item: {
		...commonCard,
	},
	header: {
		marginBottom: spacing.s,
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	content: {
		// Add specific content styles if needed
	},
	fab: {
		...buttonStyles.fab,
	},
	emptyContainer: {
		...commonEmptyState,
	},
});
